<template>
  <div class="container">
    <div class="topbar">
      <h3 class="title">{{ title }}</h3>
      <div class="button-group">
        <a-range-picker
          class="range-picker lianedate"
          @change="changeDate"
          :value="showDate"
          :disabledDate="disabledDate"
        >
          <template slot="renderExtraFooter"></template>
        </a-range-picker>
        <a-button-group>
          <a-button :type="lineChartChooseTypeOne" @click="chooseButtonOne()">一周</a-button>
          <a-button :type="lineChartChooseTypeTwo" @click="chooseButtonTwo()">十五天</a-button>
          <a-button :type="lineChartChooseTypeThree" @click="chooseButtonThree()">一个月</a-button>
        </a-button-group>
      </div>
    </div>
    <div class="countDate">
      <a-spin :spinning="loadingLine">
        <div class="sendInfo" style="width: 100%">
          <div class="countItem">
            <p style="color: rgba(0, 0, 0, 0.45)">发送总量</p>
            <p style="color: #1cc4e5; font-size: 28px">{{ successCount + errorCouant + countWait }}</p>
          </div>
          <div class="countItem">
            <p style="color: rgba(0, 0, 0, 0.45)">发送成功</p>
            <p style="color: #1ce579; font-size: 28px">{{ successCount }}</p>
          </div>
          <div class="countItem">
            <p style="color: rgba(0, 0, 0, 0.45)">发送失败</p>
            <p style="color: #e52a1c; font-size: 28px">{{ errorCouant }}</p>
          </div>
          <div class="countItem">
            <p style="color: rgba(0, 0, 0, 0.45)">等待报告</p>
            <p style="color: #ffdead; font-size: 28px">{{ countWait }}</p>
          </div>
        </div>
      </a-spin>
    </div>

    <div class="chart">
      <a-skeleton :loading="loadingLine">
        <div class="charitem">
          <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :padding="padding">
            <v-tooltip :crosshairs="crosshairs" :shared="true" />
            <v-axis dataKey="countNumber" position="left" />
            <v-legend />
            <v-line
              position="countTime*countNumber"
              :color="['countType', ['#1ce579', '#E52A1C', '#1cc4e5', '#FFDEAD']]"
            />
            <v-point
              position="countTime*countNumber"
              :color="['countType', ['#1ce579', '#E52A1C', '#1cc4e5', '#FFDEAD']]"
              size="4"
              shape="circle"
              :style="style"
            />
          </v-chart>
        </div>
      </a-skeleton>
    </div>
  </div>
</template>


<script>
import moment from 'moment'
import { everyCount, allCount } from '@/api/api'

const scale = [
  {
    dataKey: 'countTime',
  },
]

const crosshairs = {
  type: 'line',
}

const style = {
  stroke: '#fff',
  lineWidth: 1,
}

export default {
  data() {
    return {
      title: '短信发送量数据折线图',
      data: [],
      scale,
      height: 400,
      crosshairs,
      style,
      lineChartChooseTypeOne: '',
      lineChartChooseTypeTwo: '',
      lineChartChooseTypeThree: '',
      lineChartDate: [],
      showDate: [
        moment(moment(new Date()).subtract(2, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ],
      dateFormat: 'YYYY-MM-DD',
      loadingLine: false,
      successCount: 0,
      errorCouant: 0,
      countWait: 0,
      padding: [20, 100, 'auto', 'auto'],
    }
  },
  mounted() {
    this.chooseButtonOne()
    this.getAllCount()
  },
  methods: {
    disabledDate(current) {
      return current > moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
    },
    chooseButtonOne() {
      this.lineChartChooseTypeOne = 'primary'
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = ''
      this.lineChartDate[0] = moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.showDate[0] = moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      this.getAllCount()
    },
    chooseButtonTwo() {
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = 'primary'
      this.lineChartChooseTypeThree = ''
      this.lineChartDate[0] = moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.showDate[0] = moment(moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      this.getAllCount()
    },
    chooseButtonThree() {
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = 'primary'
      this.lineChartDate[0] = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
      this.lineChartDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.showDate[0] = moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.showDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getLineChartDate()
      this.getAllCount()
    },
    changeDate(dates, dateStrings) {
      this.showDate = dates
      this.lineChartDate[0] = dateStrings[0]
      this.lineChartDate[1] = dateStrings[1]
      this.lineChartChooseTypeOne = ''
      this.lineChartChooseTypeTwo = ''
      this.lineChartChooseTypeThree = ''
      this.getLineChartDate()
      this.getAllCount()
    },
    getLineChartDate() {
      this.loadingLine = true
      let params = {
        endTime: this.lineChartDate[1],
        startTime: this.lineChartDate[0],
      }
      everyCount(params).then((res) => {
        if (res.success) {
          this.data = res.result[0]
          this.data = this.data.concat(res.result[1])
          this.data = this.data.concat(res.result[2])
          this.data = this.data.concat(res.result[3])
          this.loadingLine = false
        } else {
          // this.chooseButtonOne()
        }
      })
    },
    getAllCount() {
      let params = {
        endTime: this.lineChartDate[1],
        startTime: this.lineChartDate[0],
      }
      allCount(params).then((res) => {
        if (res.success) {
          this.successCount = res.result.countSuccess
          this.errorCouant = res.result.countFail
          this.countWait = res.result.countWait
        } else {
          // this.chooseButtonOne()
        }
      })
    },
  },
}
</script>


<style lang="less">
.linedate {
  /deep/ .ant-calendar-picker-icon {
    display: none !important;
  }
}
</style>


<style scoped>
.container {
  padding-top: 10px;
  margin-left: 1%;
  width: 100%;
  background-color: #ffffff;
}
.title {
  height: 100%;
  width: 49%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.chart {
  margin-top: 10%;
  margin-left: 2%;
  width: 95%;
  height: 100%;
  text-align: center;
}
.charitem {
  width: 96%;
  margin: auto;
}
.button-group {
  height: 100%;
  width: 49%;
  display: inline-block;
  text-align: right;
}
.topbar {
  height: 100%;
  width: 98%;
}

.range-picker {
  width: 35%;
  margin-right: 3%;
}

.countItem {
  width: 22%;
  float: left;
  height: 80px;
  margin-left: 3%;
  margin-top: 2%;
  text-align: center;
}
</style>
